import { useQuery } from "react-query";
import axios from "axios";
import Config from "../Config";
import { useSelector } from "react-redux";

const useReturns = () => {
    const user = useSelector((state) => state.UserReducer.user);

    return useQuery(
        ['returns', user?.token],
        async () => {
            const { data } = await axios.get(`${Config.apiUrl}/returns`, {
                headers: { Authorization: `Bearer ${user.token}` },
            });
            return data.data || data; 
        },
        {
            enabled: !!user?.token,
            staleTime: 1000 * 60 * 2, // Cache for 2 minutes
        }
    );
};

export default useReturns;